import React from 'react';
import { Grid, Row, Cell } from '@dexma/ui-components';

import i18n from 'asset/translation';
import { StyledConfirmActionModal, StyledModalLabelParagraph } from 'adapter/in/common/components/ConfirmActionModal/style';
import ServerErrorAlert from 'adapter/in/dashboards/components/ServerErrorAlert';
import {
    ButtonVariant,
    ConfirmButtonGroup,
    ConfirmButtonGroupsDataIdContext,
} from 'adapter/in/common/components/ConfirmButtonGroup/ConfirmButtonGroup';

const ConfirmActionModal = ({
    isOpen,
    onClose,
    mainButton,
    optionalButton,
    message,
    title,
    mainButtonText,
    optionalButtonText,
    mainButtonVariant,
    dataIdContext,
    isLoading,
    disableMainButton,
    hasError,
    optionalButtonVariant,
    children,
}: {
    isOpen: boolean;
    onClose: () => void;
    mainButton: () => void;
    title: string;
    mainButtonText: string;
    message?: string;
    optionalButton?: () => void;
    optionalButtonText?: string;
    optionalButtonVariant?: ButtonVariant;
    mainButtonVariant?: ButtonVariant;
    dataIdContext: ConfirmButtonGroupsDataIdContext & { tryAgain: string };
    disableMainButton?: boolean;
    isLoading?: boolean;
    hasError?: boolean;
    children?: React.ReactNode;
}) => {
    const handleConfirm = () => {
        mainButton();
    };

    const footer = (
        <ConfirmButtonGroup
            isLoading={!!isLoading}
            onMainClick={handleConfirm}
            onCancel={onClose}
            mainButtonText={mainButtonText}
            optionalButtonText={optionalButtonText}
            onOptionalClick={optionalButton}
            mainButtonVariant={mainButtonVariant}
            optionalButtonVariant={optionalButtonVariant}
            disableMainButton={disableMainButton}
            dataIdContext={dataIdContext}
            proceedType='button'
        />
    );

    return (
        <StyledConfirmActionModal
            width={600}
            open={isOpen}
            onCancel={onClose}
            title={title}
            hasSaveAndProceedButton={!!optionalButton}
            footer={footer}
            closeModalButtonAriaLabel={i18n.t('common.ariaLabel.closeModalIcon')}
            body={
                <Grid fluid className='no-padding-grid' data-testid='confirm-changes-modal'>
                    <Row>
                        {hasError && (
                            <Cell>
                                <ServerErrorAlert
                                    tryAgain={() => (optionalButton ? optionalButton() : mainButton())}
                                    dataId={dataIdContext ? dataIdContext.tryAgain : ''}
                                />
                            </Cell>
                        )}
                    </Row>
                    {message && (
                        <Row>
                            <Cell xs={12}>
                                <StyledModalLabelParagraph>{message}</StyledModalLabelParagraph>
                            </Cell>
                        </Row>
                    )}
                    {children}
                </Grid>
            }
        />
    );
};

export default ConfirmActionModal;
